var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bottom-bar pfixed bottom-left bottom-right h-7 bt-1" },
    [
      _c(
        "div",
        { staticClass: "flex-level container-medium mx-auto my-4 px-4" },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }